import React, { useContext } from "react";
import styles from "@/page-components/taggings/tagging.module.css";
import addWidget from "@/assets/img/addWidget.svg";
import { TaggingContext } from "../tagging-context-file";
import CreateVirtualTagModal from "./create-virtual-tag-modal";

const TaggingHeading = ({
  service,
  deleteError,
  deleteSuccess,
  deleteLoading,
  deleteData,
}) => {
  const context = useContext(TaggingContext);

  return (
    <>
      <div className={styles.headerSectionTextP}>
        <div className={styles.headerSection}>
          <span className={styles.costText}>
            Virtual Tag Allocation
          </span>
          {/* <span className={styles.costTextp}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
            fringilla eros id erat ultricies
          </span> */}
        </div>
        <div
          className=" btn add_new_widgets"
          onClick={() => {
            context?.setIsLayoverOpen(true);
          }}
        >
          <img className="add_widgte_svg" src={addWidget} alt=" " />
          <span className="add_widget_text">Create a Virtual Tag</span>
        </div>
      </div>
      <CreateVirtualTagModal
        service={service}
        deleteError={deleteError}
        deleteSuccess={deleteSuccess}
        deleteLoading={deleteLoading}
        deleteData={deleteData}
      />
    </>
  );
};

export default TaggingHeading;
